import React from "react";
import { stepThreeData } from "../stepsData";
import { paragraphStyle, headingStyle } from "../../../../calculatorStyleData";
import { Typography } from "@mui/material";

const StepThree = () => {
  return (
    <>
      <div id="step-three">
        <div id="list_data" className="">
          <Typography sx={headingStyle}>
            <strong>{stepThreeData[0].heading}</strong>
          </Typography>
          <div>
            <ul
              style={{
                listStyle: "disc",
                fontSize: 16,
                color: "#1f1f1f",
                lineHeight: "24px",
              }}
              className=" archivo "
            >
              {stepThreeData[0].infoList &&
                stepThreeData[0].infoList.map((item, index) => (
                  <li key={index}>
                    <Typography sx={paragraphStyle}>
                      {" "}
                      <strong>{item.info}</strong> {item.description}
                    </Typography>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div id="list_data" className="mt-3">
          <Typography sx={headingStyle} className="pb-3">
            <strong>{stepThreeData[0].minemiTip}</strong>
          </Typography>
          <Typography sx={paragraphStyle}>
            {stepThreeData[0].tipSubhead}
          </Typography>
          <div>
            <ol
              style={{
                listStyle: "number",
                fontSize: 16,
                color: "#1f1f1f",
                lineHeight: "24px",
              }}
              className=" archivo "
            >
              {stepThreeData[0].tipInfoList &&
                stepThreeData[0].tipInfoList.map((item, index) => (
                  <li key={index} className="mt-3">
                    <Typography sx={paragraphStyle}>
                      {" "}
                      <strong>{item.info}</strong> {item.description}
                    </Typography>
                  </li>
                ))}
            </ol>
          </div>
        </div>
        {/* When Not to Transfer Your Loan */}
        <div id="list_data" className="mt-3">
          <Typography sx={headingStyle} className="pb-3">
            <strong>{stepThreeData[1].transferlone}</strong>
          </Typography>
          <Typography sx={paragraphStyle}>
            {stepThreeData[1].subhead}
          </Typography>
          <div>
            <ul
              style={{
                listStyle: "disc",
                fontSize: 16,
                color: "#1f1f1f",
                lineHeight: "24px",
              }}
              className=" archivo "
            >
              {stepThreeData[1].infoList &&
                stepThreeData[1].infoList.map((item, index) => (
                  <li key={index}>
                    <Typography sx={paragraphStyle}>
                      {" "}
                      <strong>{item.info}</strong> {item.description}
                    </Typography>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div id="list_data" className="mt-3 d-flex flex-column gap-3">
          <Typography sx={paragraphStyle}>
            <strong>{stepThreeData[1].paraOne}</strong>
          </Typography>
          <Typography sx={paragraphStyle}>
            {stepThreeData[1].paraTwo}
          </Typography>
          <Typography sx={paragraphStyle}>
            {stepThreeData[1].paraThree}
          </Typography>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default StepThree;
